var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 35.4001V119.6C108.8 120.292 108.662 120.976 108.395 121.613C108.127 122.251 107.735 122.829 107.242 123.313C106.748 123.797 106.163 124.178 105.521 124.433C104.878 124.689 104.191 124.813 103.5 124.8H28.6C27.2209 124.8 25.8982 124.252 24.9231 123.277C23.9479 122.302 23.4 120.979 23.4 119.6V22.2001C23.3867 21.5089 23.5114 20.822 23.7668 20.1795C24.0221 19.537 24.403 18.9519 24.8872 18.4584C25.3714 17.9649 25.9492 17.5729 26.5867 17.3053C27.2242 17.0378 27.9086 16.9 28.6 16.9001H91.1L108.8 35.4001Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 75.6001L144.3 78.5001L123.2 99.6001L113.8 90.3001L116.7 87.4001L123.2 93.9001L141.5 75.6001Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 111.3V109.7C41.4 109.5 39.3 107.8 39.3 105.3H40.7001C40.8001 107 42.3 108.2 44.3 108.4V102.1L43.7001 101.9C41.0001 101.2 39.7001 99.9001 39.7001 97.9001C39.7001 95.9001 41.5 93.8001 44.3 93.6001V92.1001H45.5V93.6001C48.2 93.8001 50.1 95.5001 50.2001 97.8001H48.8C48.6819 97.0045 48.2855 96.2765 47.6813 95.7456C47.0771 95.2146 46.3043 94.915 45.5 94.9001V100.9H46.1C49.2 101.7 50.5 103 50.5 105.2C50.5 107.4 48.5 109.4 45.5 109.6V111.2L44.3 111.3ZM44.3 100.6V94.9001C43.4943 94.8724 42.7094 95.1598 42.112 95.7012C41.5146 96.2426 41.1516 96.9955 41.1 97.8001C41.1 99.3001 42.1 100.1 44.3 100.6ZM45.5 102.3V108.4C47.6 108.3 49 107.2 49 105.4C49 103.6 48 102.9 45.5 102.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1 46.7H41.1V50.7H91.1V46.7Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8 129.4L95.6 132.7C95.4729 134.089 94.8031 135.372 93.736 136.271C92.669 137.169 91.2906 137.611 89.9 137.5L15.3 130.9C14.6116 130.863 13.9379 130.687 13.3196 130.382C12.7013 130.077 12.1512 129.65 11.7025 129.126C11.2539 128.603 10.916 127.994 10.7093 127.336C10.5026 126.679 10.4314 125.986 10.5 125.3L19 28.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 35.5H91.4V15.2",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 16.8C38.9058 16.1873 38.9452 15.5614 39.1154 14.9652C39.2857 14.3691 39.5828 13.8169 39.9865 13.3463C40.3902 12.8758 40.8909 12.4981 41.4542 12.2392C42.0175 11.9803 42.6301 11.8462 43.2501 11.8462C43.87 11.8462 44.4827 11.9803 45.046 12.2392C45.6093 12.4981 46.1099 12.8758 46.5136 13.3463C46.9173 13.8169 47.2145 14.3691 47.3847 14.9652C47.555 15.5614 47.5943 16.1873 47.5001 16.8V33.2C47.5001 33.757 47.2788 34.2911 46.885 34.685C46.4912 35.0788 45.957 35.3 45.4001 35.3C44.8431 35.3 44.309 35.0788 43.9152 34.685C43.5213 34.2911 43.3001 33.757 43.3001 33.2V33.2V22.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7001 61.9001H92.5001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7001 71.9001H92.5001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7001 81.8999H75.0001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58 107.2H92.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.7 86.8C143.992 88.0789 144.126 89.3886 144.1 90.7C144.1 94.6557 142.927 98.5224 140.729 101.811C138.532 105.1 135.408 107.664 131.754 109.178C128.099 110.691 124.078 111.087 120.198 110.316C116.319 109.544 112.755 107.639 109.958 104.842C107.161 102.045 105.256 98.4815 104.484 94.6018C103.713 90.7222 104.109 86.7009 105.622 83.0464C107.136 79.3918 109.7 76.2683 112.989 74.0706C116.278 71.873 120.144 70.7 124.1 70.7C128.012 70.6892 131.84 71.8375 135.1 74",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceCheckmark);
export default __webpack_public_path__ + "static/media/invoice_checkmark.405a696503067209b4ef391579656031.svg";
export { ForwardRef as ReactComponent };